import React, { FC } from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const RequestsToAddPage: FC<any> = ({ childRoutes }): React.ReactElement => (
	<div>
		<Route
			path="/buyer/requestsToAdd"
			exact={true}
			render={() => (
				<Redirect
					to={{
						pathname: '/buyer/requestsToAdd/overview',
					}}
				/>
			)}
		/>
		{childRoutes.map((route, index) => (
			<RouteWithSubRoutes key={index} {...route} />
		))}
	</div>
);

export default RequestsToAddPage;
